<template>
        <div id="video-canvas">
                <div v-if="updateComponent"></div>
                <timer style="grid-area: 1/2/span 1/span 12; z-index: 9999;color:white" :date="new Date()"
                        v-if="videoTrackList.length>1"></timer>
                <div class="spinner d-flex flex-column align-items-center" style v-if="!readyState">
                        <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                        </div>
                        <h5 class="text-center">Connecting..</h5>
                </div>
                <div class="call-control-buttons-group">
                        <button title="Open Chat" class="btn btn-success btn-circle btn-xl call-control-buttons"
                                @click.prevent="$emit('toggleChat')">
                                <i class="material-icons"> chat </i>
                        </button>
                        <button @click.prevent="handleExit"
                                class="btn btn-danger btn-circle btn-xl call-control-buttons exitBtn"
                                :class="{'disabled': !readyState}" title="Exit">
                                <i class="material-icons large call-end">call_end</i>
                        </button>
                        <button @click.prevent="handleCamera"
                                class="btn btn-primary btn-circle btn-xl call-control-buttons videoControlBtn"
                                title="Enable/Disable Video">
                                <i class="material-icons camera">videocam</i>
                                <i class="material-icons camera-off">videocam_off</i>
                        </button>
                        <button @click.prevent="handleMic"
                                class="btn btn-primary btn-circle btn-xl call-control-buttons audioControlBtn"
                                title="Enable/Disable Audio">
                                <i class="material-icons mic">mic</i>
                                <i class="material-icons mic-off">mic_off</i>
                        </button>
                </div>

        </div>
</template>

<script>
        import constants from '../config/constants';
        // import { db, firebase } from "../firebase";
        const tile_canvas = {
                "1": ["1/1/span 12/span 24"],
                "2": ["span 12/span 12/13/25", "span 12/span 12/13/13"],
                "3": ["span 6/span 12", "span 6/span 12", "span 6/span 12/7/19"],
                "4": [
                        "span 6/span 12",
                        "span 6/span 12",
                        "span 6/span 12",
                        "span 6/span 12/7/13",
                ],
                "5": [
                        "span 3/span 4/13/9",
                        "span 3/span 4/13/13",
                        "span 3/span 4/13/17",
                        "span 3/span 4/13/21",
                        "span 9/span 16/10/21",
                ],
                "6": [
                        "span 3/span 4/13/7",
                        "span 3/span 4/13/11",
                        "span 3/span 4/13/15",
                        "span 3/span 4/13/19",
                        "span 3/span 4/13/23",
                        "span 9/span 16/10/21",
                ],
                "7": [
                        "span 3/span 4/13/5",
                        "span 3/span 4/13/9",
                        "span 3/span 4/13/13",
                        "span 3/span 4/13/17",
                        "span 3/span 4/13/21",
                        "span 3/span 4/13/25",
                        "span 9/span 16/10/21",
                ],
        };

        export default {
                data() {
                        return {
                                client: {},
                                localAudio: {},
                                localVideo: {},
                                localStream: {},
                                videoTrackList: [],
                                readyState: false,
                                updateComponent: true,
                                infoMessages: [],
                                errors: [],
                        };
                },

                props: ["videoProfile", "channel", "appId", "uid", "token"],

                methods: {

                        subscribeStreamEvents() {
                                let rt = this;

                                rt.client.on("user-published", async (remoteUser, mediaType) => {
                                        await rt.client.subscribe(remoteUser, mediaType);
                                        if (mediaType === "video") {
                                                rt.addVideoTrack(remoteUser.videoTrack);
                                                rt.$emit('userJoined');
                                        }
                                        if (mediaType === "audio") {
                                                remoteUser.audioTrack.play();
                                        }
                                });
                                rt.client.on("user-left", async (remoteUser, reason) => {
                                        rt.removeVideoTrack(remoteUser.uid);
                                        rt.$emit('userLeft');

                                });
                        },

                        removeVideoTrack(uid) {
                                let $ = this;

                                $.videoTrackList.map((item, index) => {

                                        if (item.userId === uid) {
                                                item.stop();
                                                let element = document.querySelector("#ag-item-" + item
                                                        .getTrackId());
                                                if (element) {
                                                        element.parentNode.removeChild(element);
                                                }
                                                let tempList = [...$.videoTrackList];
                                                tempList.splice(index, 1);
                                                $.videoTrackList = tempList;
                                        }
                                });
                        },

                        addVideoTrack(track, push = false, isLocal = false) {
                                let repeatition = this.videoTrackList.some((item) => {
                                        return item.getTrackId() === track.getTrackId();
                                });
                                if (repeatition) {
                                        return;
                                }
                                if (isLocal) {
                                        track.userId = this.uid;
                                } else {
                                        track.userId = track.getUserId();
                                }
                                if (push) {
                                        this.videoTrackList = this.videoTrackList.concat([track]);
                                } else {
                                        this.videoTrackList = [track].concat(this.videoTrackList);
                                }
                                this.videoTrackList.reverse();
                                this.forceUpdateComponent();
                        },

                        handleCamera(e) {
                                e.currentTarget.classList.toggle("off");
                                this.localVideo.muted ?
                                        this.localVideo.setMuted(false) :
                                        this.localVideo.setMuted(true);
                        },

                        handleMic(e) {
                                e.currentTarget.classList.toggle("off");
                                this.localAudio.muted ?
                                        this.localAudio.setMuted(false) :
                                        this.localAudio.setMuted(true);
                        },

                        handleExit(e) {

                                if (e.currentTarget.classList.contains("disabled")) {
                                        return;
                                }
                                try {
                                        // this.$store.dispatch("stopSound");
                                        this.client && this.client.unpublish([this.localAudio, this.localVideo]);
                                        this.localAudio && this.localAudio.close();
                                        this.localVideo && this.localVideo.close();
                                        // let status = 0;
                                        // if (this.isCaller && this.$store.getters.channelInfo.status < 5) {
                                        //   status = myConsts.VIDEO_CANCELLED_BY_CALLER;
                                        // } else if (this.isCaller) {
                                        //   status = 7;
                                        // } else {
                                        //   status = 8;
                                        // }
                                        // db.ref(`testvideocall/${this.channel}`).update({ status: status });
                                        // this.$store.dispatch("setLocalBusyStatus", false);
                                        // this.$store.dispatch("setFbBusyStatus", false);
                                        this.client &&
                                                this.client.leave();
                                } finally {
                                        this.readyState = false;
                                        this.client = null;
                                        this.localStream = null;
                                        // redirect to index
                                        this.$router.push("/");
                                }
                        },
                        forceUpdateComponent() {
                                this.updateComponent = !this.updateComponent;
                        },
                        async initAgoraV4() {
                                let $ = this;
                                $.client = await AgoraRTC.createClient({
                                        mode: "rtc",
                                        codec: "vp8"
                                });
                                $.localAudio = await AgoraRTC.createMicrophoneAudioTrack();
                                $.localVideo = await AgoraRTC.createCameraVideoTrack();
                                try {
                                        $.subscribeStreamEvents();

                                        const uid = await $.client.join($.appId, $.channel, $.token, $.uid);

                                } catch (e) {
                                        console.log("join failed", e);
                                }
                                try {
                                        if (this.channel && this.uid) {
                                                database.ref().child('channelInfo').child($.channel).child($
                                                        .uid).set(true);

                                        }

                                        $.addVideoTrack($.localVideo, true, true);
                                        await $.client.publish([$.localAudio, $.localVideo]);

                                        $.readyState = true;
                                } catch (e) {
                                        console.error(e);
                                        $.readyState = true;
                                }
                        },
                },

                created() {
                        let $ = this;
                        if(!$.uid || !$.token) {
                                return;
                        } else {
                        $.initAgoraV4();

                        }
                },

                mounted() {
                        this.$nextTick(() => {
                                let canvas = document.querySelector("#video-canvas");
                                let btnGroup = document.querySelector(".call-control-buttons-group");
                                if(!canvas) return;
                                canvas.addEventListener("mousemove", () => {
                                        if (global._toolbarToggle) {
                                                clearTimeout(global._toolbarToggle);
                                        }
                                        btnGroup.classList.add("active");
                                        global._toolbarToggle = setTimeout(function () {
                                                btnGroup.classList
                                                        .remove(
                                                                "active");
                                        }, 2000);
                                });
                        });
                },

                beforeUpdate() {
                        let $ = this;
                        // rerendering
                        let canvas = document.querySelector("#video-canvas");
                        let no = $.videoTrackList.length;
                        $.videoTrackList.map((item, index) => {
                                let id = item.getTrackId();
                                let dom = document.querySelector("#ag-item-" + id);
                                if (!dom) {
                                        dom = document.createElement("section");
                                        dom.setAttribute("id", "ag-item-" + id);
                                        dom.setAttribute("class", "ag-item");
                                        canvas.appendChild(dom);
                                        item.play("ag-item-" + id);
                                }
                                if (index === no - 1) {
                                        dom.setAttribute("style", `grid-area: span 12/span 24/13/25`);
                                } else {
                                        dom.setAttribute(
                                                "style",
                                                `grid-area: span 3/span 4/${4 + 3 * index}/25;
          z-index:1;width:calc(100% - 20px);height:calc(100% - 20px)`
                                        );
                                }
                                item && item.player && item.player.resize && item.player.resize();
                        });
                },

                beforeDestroy() {
                        if (this.channel && this.uid)
                                database.ref().child('channelInfo').child(this.channel).child(this.uid).set(false);
                        try {
                        this.client && this.client.unpublish([this.localAudio, this.localVideo]);
                        this.localAudio && this.localAudio.close();
                        this.localVideo && this.localVideo.close();
                        this.client &&
                                this.client.leave();}catch(e) {
                                        

                                }
                },
        };
</script>

<style>
        #video-canvas {
                height: 100vh;
                display: grid;
                grid-gap: 10px;
                align-items: center;
                justify-items: center;
                grid-template-rows: repeat(12, 1fr);
                grid-template-columns: repeat(24, 1fr);
        }

        .ag-item :first-child {
                border-radius: 6px;
        }

        .ag-item {
                border-radius: 6px;
                border: 2px #1a1653 solid;
                height: 100%;
                width: 100%;
        }

        #ag-resize-container {
                background-image: none !important;
                background-color: black;
                display: flex;
                justify-content: center;
                height: center;
        }

        #ag-resize-container .ag-item {
                border: none !important;
        }

        /* button group */
        .call-control-buttons-group {
                height: 80px;
                width: 100%;
                margin: 0 auto;
                position: absolute;
                bottom: 0;
                background: transparent;
                z-index: 11;
                display: flex;
                justify-content: space-around;
                align-items: center;
        }

        .call-control-buttons-group:hover,
        .call-control-buttons-group.active {
                background: rgba(73, 75, 159, 0.5)
        }

        .call-control-buttons {
                z-index: 12;
                opacity: 0;
                color: white;
                /* width: 35px;
    height: 35px; */
                cursor: pointer;
                display: inline-flex;
                justify-content: center;
                align-items: center;
        }

        .call-control-buttons:hover {
                color: #00b6ed;
        }

        .call-control-buttons.disabled,
        .call-control-buttons.disabled:hover {
                color: #637c8e;
                cursor: not-allowed;
        }

        .call-control-buttons-group:hover .call-control-buttons,
        .call-control-buttons-group.active .call-control-buttons {
                opacity: 1;
        }

        .call-control-buttons.off.exitBtn .call-end {
                display: none;
        }

        .call-control-buttons.off.videoControlBtn .camera {
                display: none;
        }

        .call-control-buttons.videoControlBtn .camera-off {
                display: none;
        }

        .call-control-buttons.videoControlBtn .camera {
                display: inline-block;
        }

        .call-control-buttons.off.videoControlBtn .camera-off {
                display: inline-block;
        }

        .call-control-buttons.off.audioControlBtn .mic {
                display: none;
        }

        .call-control-buttons.audioControlBtn .mic-off {
                display: none;
        }

        .call-control-buttons.audioControlBtn .mic {
                display: inline-block;
        }

        .call-control-buttons.off.audioControlBtn .mic-off {
                display: inline-block;
        }

        .btn-circle.btn-sm {
                width: 30px;
                height: 30px;
                padding: 6px 0px;
                border-radius: 15px;
                text-align: center;
        }

        .btn-circle.btn-md {
                width: 50px;
                height: 50px;
                padding: 7px 10px;
                border-radius: 25px;
                text-align: center;
        }

        .btn-circle.btn-xl {
                width: 70px;
                height: 70px;
                padding: 10px 16px;
                border-radius: 35px;
                text-align: center;
        }

        video {
                max-width: unset !important;
        }

        .material-icons {
                font-size: 30px;
                font-weight: bold;
        }

        .spinner {
                grid-area: 6/12;
        }
</style>